import { OrderTabsEnum } from 'types/Order.types';

export const tabs = [
  { id: OrderTabsEnum.Company, label: 'Company' },
  { id: OrderTabsEnum.Products, label: 'Products' },
  { id: OrderTabsEnum.Overview, label: 'Overview' },
  { id: OrderTabsEnum.Details, label: 'Details' },
];
